import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { RoutinesComponent } from './routines.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RoutinesService } from './routines.service';
import { RoutinesDialogComponent } from './routines-dialog/routines-dialog.component';
import { RoutinesCardComponent } from './routines-card/routines-card.component';
import { NewRoutinesCardComponent } from './new-routines-card/new-routines-card.component';
import { MatProgressBarModule, MatProgressSpinnerModule } from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    SharedModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
  ],
  entryComponents: [
    RoutinesDialogComponent
  ],
  declarations: [
    RoutinesComponent,
    RoutinesDialogComponent,
    RoutinesCardComponent,
    NewRoutinesCardComponent
  ],
  exports: [
    MatProgressBarModule,
    MatProgressSpinnerModule,
  ],
  providers: [RoutinesService]
})
export class RoutinesModule { }



// WEBPACK FOOTER //
// ./src/app/entities/routines/routines.module.ts